import { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { CiLogout } from "react-icons/ci";
import { FaRegEdit } from "react-icons/fa";
import {
  IoIosArrowDown,
  IoMdNotificationsOutline,
  IoMdSettings,
} from "react-icons/io";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import userImage from "../../assets/images/user.jpg";
import "../DashboardTopRight.scss";

import { useTranslation } from "react-i18next";
import { server } from "../../App";
import {
  useGetRecentNotificationsQuery,
  useGetUnreadNotificationCountQuery,
  useMarkAllNotificationsAsReadMutation,
} from "../../store/api/admin/notificationsSlice";
import { connectSocketWithUserId, socket } from "../../utils/socket.js";
import { OutsideClickHandler } from "../Sidebar/OutsideClickHandler.js";

const VendorHeader = ({ logOut, LanguageSlector }) => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.UserReducer);

  const [isVisible, setIsVisible] = useState(false);
  const [notifLimit, setNotifLimit] = useState(10);
  const [markAllAsRead] = useMarkAllNotificationsAsReadMutation();
  const {
    data: notifData,
    refetch,
    isFetching: notifLoading,
    isUninitialized: notifUninitialized,
  } = useGetRecentNotificationsQuery(notifLimit);
  const {
    data: countData,
    refetch: refetchCount,
    isUninitialized: countUninitialized,
  } = useGetUnreadNotificationCountQuery();

  const notificationItems = notifData?.data?.notifications || [];
  const totalNotification = countData?.data?.unreadCount || 0;
  const hasMore = notificationItems.length >= notifLimit;

  const toggleVisibility = async () => {
    setIsVisible((v) => !v);
    if (!isVisible) {
      await markAllAsRead().catch(() => {});
      refetchCount();
    }
  };
  const handleOutsideClick = () => {
    setIsVisible(false);
  };

  useEffect(() => {
    if (!user || (!user.id && !user._id)) return;

    connectSocketWithUserId(user.id || user._id);

    const onNewNotification = () => {
      if (!notifUninitialized) refetch();
      if (!countUninitialized) refetchCount();
    };

    socket.on("new_notification", onNewNotification);
    socket.on("update-compliance-notification", onNewNotification);

    return () => {
      socket.off("new_notification", onNewNotification);
      socket.off("update-compliance-notification", onNewNotification);
    };
  }, [user, refetch, refetchCount, notifUninitialized, countUninitialized]);

  const profileimage = !!user.profile_image
    ? `${server}${user?.profile_image}`
    : userImage;

  const firstname = !!user?.full_name ? user?.full_name : "No Name";

  return (
    <>
      {/* dbheaderRight */}
      <div className="d-flex align-items-center justify-content-between">
        {/* <div className="dbLogoMob">
          <NavLink to="/vendor/dashboard">
            <img src={Logo} alt="" />
          </NavLink>
        </div> */}
        <div className="d-flex align-items-center">
          <LanguageSlector />
          <div className="notificationBox">
            <OutsideClickHandler onOutsideClick={handleOutsideClick}>
              <NavLink
                onClick={toggleVisibility}
                className="notification me-3 d-flex align-items-center justify-content-center rounded-circle"
              >
                <IoMdNotificationsOutline />
                {totalNotification > 0 && (
                  <span className="badge rounded-circle d-flex align-items-center justify-content-center">
                    {totalNotification}
                  </span>
                )}
              </NavLink>

              {isVisible && (
                <div className="notificationPoup">
                  <div className="notif-header">{t("notifications")}</div>
                  <ul>
                    {notificationItems.length > 0 ? (
                      notificationItems.map((item, index) => (
                        <li
                          key={index}
                          className={
                            item.is_read === 0
                              ? "unread-notification"
                              : "read-notification"
                          }
                        >
                          <div className="notif-item">
                            <div className="notif-title">{item.title}</div>
                            <p className="notif-message">{item.message}</p>
                          </div>
                        </li>
                      ))
                    ) : (
                      <div className="notif-empty">
                        {`${t("no")} ${t("notification")} ${t("found")}`}
                      </div>
                    )}
                  </ul>
                  {hasMore && (
                    <div className="notif-load-more">
                      <button
                        onClick={() => setNotifLimit((l) => l + 10)}
                        disabled={notifLoading}
                        className="btn btn-outline-primary"
                      >
                        {notifLoading
                          ? `${t("loading")}${t("...")}`
                          : `${t("load")} ${t("more")}`}
                      </button>
                    </div>
                  )}
                </div>
              )}
            </OutsideClickHandler>
          </div>

          <Dropdown className="acLinkBox position-relative">
            <Dropdown.Toggle className="acLink">
              <img src={profileimage} alt="" className="rounded-circle me-2" />{" "}
              <span>
                {`${firstname}`}
                <IoIosArrowDown className="ms-1" />
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <NavLink to="/profile" className="d-flex align-items-center">
                <FaRegEdit className="me-2 icon" />{" "}
                {`${t("my")} ${t("profile")}`}
              </NavLink>
              <NavLink to="/settings" className="d-flex align-items-center">
                <IoMdSettings className="me-2 icon" /> {t("settings")}
              </NavLink>
              <NavLink className="d-flex align-items-center" onClick={logOut}>
                <CiLogout className="me-2 icon" /> {t("logout")}
              </NavLink>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </>
  );
};
export default VendorHeader;
